import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
const guarantees = ['Téléchargement Instantané', 'Zéro Abonnement', 'Accès à Vie', 'Garantie 7 Jours'];
export function Hero() {
  return <section className="w-full bg-cream px-5 pb-20 pt-5" data-id="element-106" data-mp="9lbhb4dgrhf6">
      <div className="mx-auto max-w-4xl text-center" data-id="element-107" data-mp="4m8nyh6uizn1">
        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="font-display text-[2rem] font-black leading-[1.06] tracking-tight text-ink sm:text-5xl md:text-[3.4rem]" data-id="element-108" data-mp="4njpsbgqdxbi">
          Réglez toute une année d&apos;Arts Plastiques en seulement{' '}
          <span className="italic text-brand" data-id="element-109" data-mp="nbf0tnkykx0x">5 minutes</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.08,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-ink/60 sm:text-lg" data-id="element-110" data-mp="3d2lapfhgtb2a">
          Rejoignez plus de 2 000 professeurs qui ont arrêté d&apos;improviser.
          Entrez dans chaque classe avec tout votre matériel prêt pour
          enseigner, créer et inspirer.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.16,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-2 max-w-3xl pb-5 pt-2.5 sm:mt-8" data-id="element-111" data-mp="3e8mqgsg72bbg">
          <img src="https://cdn.magicpatterns.com/uploads/oQohDDjj4d1i5dwqxwuD84/4dd76c11-ddd5-4d76-9d60-f31980e0a309.webp" alt="Le pack ARTS PRÊT présenté à travers 9 volumes imprimés, un ordinateur, une tablette et un téléphone" className="w-full" data-id="element-112" data-mp="2qjv4iit76p74" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.24,
        ease: [0.23, 1, 0.32, 1]
      }} className="-mt-2 sm:mt-8" data-id="element-113" data-mp="2lla9cxssyvpj">
          <CtaButton href="#offre" data-id="element-114" data-mp="najivs7dilh4" />
          <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-xs font-semibold text-ink/50 sm:text-sm" data-id="element-115" data-mp="n9i35afexat2">
            {guarantees.map((item, index) => <li key={item} className="flex items-center gap-3" data-id="element-116" data-mp="db2dlbw1a9lo" data-mpi={index}>
                <span data-id="element-117" data-mp="1azkufobi6cqm">{item}</span>
                {index < guarantees.length - 1 && <span aria-hidden="true" className="text-ink/25" data-id="element-118" data-mp="162udyzvsdf4o">
                    ·
                  </span>}
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}